import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Trash2, Plus, Pencil } from "lucide-react";

const inp = "w-full rounded-lg border border-[#1F293D] bg-[#0B0F17] px-3 py-2 text-sm text-slate-100 outline-none focus:border-sky-500";

export const QuickReplies = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ id: null, title: "", text: "" });
  const load = () => api.get("/chat/replies").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      if (form.id) await api.put(`/chat/replies/${form.id}`, form); else await api.post("/chat/replies", form);
      setForm({ id: null, title: "", text: "" }); load(); toast.success("Resposta pronta salva");
    } catch (e) { toast.error(apiError(e, "Preencha título e texto")); }
  };
  const del = async (id) => { await api.delete(`/chat/replies/${id}`); load(); };
  return (
    <div data-testid="chat-replies-admin" className="space-y-2">
      <div className="text-xs text-slate-400">Respostas prontas · use <code className="text-sky-300">{"{primeiro_nome}"}</code> para o nome do visitante</div>
      {items.map((r) => (
        <div key={r.id} data-testid={`chat-reply-row-${r.id}`} className="flex items-start gap-2 rounded-lg border border-[#1F293D] bg-[#0F141F] px-3 py-2">
          <div className="min-w-0 flex-1"><div className="text-sm font-semibold text-slate-200">{r.title}</div><div className="break-words text-xs text-slate-500">{r.text}</div></div>
          <button data-testid={`chat-reply-edit-${r.id}`} onClick={() => setForm(r)} className="p-1 text-slate-400 hover:text-white"><Pencil className="h-4 w-4" /></button>
          <button data-testid={`chat-reply-delete-${r.id}`} onClick={() => del(r.id)} className="p-1 text-slate-400 hover:text-red-300"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <div className="space-y-2 rounded-lg border border-dashed border-[#1F293D] p-3">
        <input data-testid="chat-reply-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="Título (ex.: Saudação)" maxLength={60} className={inp} />
        <textarea data-testid="chat-reply-text" value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} placeholder="Texto da resposta" rows={2} maxLength={1000} className={inp} />
        <button data-testid="chat-reply-save" onClick={save} className="inline-flex items-center gap-1.5 rounded-lg bg-sky-500 px-3 py-1.5 text-xs font-bold text-slate-950"><Plus className="h-3.5 w-3.5" /> {form.id ? "Salvar alteração" : "Adicionar resposta"}</button>
      </div>
    </div>
  );
};
